import { motion } from "framer-motion";
import { Quotes } from "@phosphor-icons/react";

const VOICES = [
  {
    quote: "Learning Lights Initiative has brought real change to our classrooms. With additional teachers and structured support, students are more attentive, confident, and improving steadily across subjects.",
    name: "Mr. D Ramulu",
    role: "Headmaster, MPUP School Gandipet",
  },
  {
    quote: "LLI gave me the opportunity to teach with purpose. The children here are eager to learn, and with proper guidance, they are showing remarkable progress day by day.",
    name: "Ms. Maloji Sharada",
    role: "Volunteer Teacher, MPUPS Gandipet",
  },
  {
    quote: "After LLI teachers joined, my child is reading better and asks more questions at home. He feels supported and excited to go to school every day.",
    name: "A Parent",
    role: "MPUP Gowlidoddi",
  },
];

const PARTNERS = ["ConnectFor", "UST", "CGI", "Avyaan Consulting", "Learning Curve", "Bright Child Foundation", "Shiva Print Gallery"];

export const Voices = () => (
  <section id="voices" className="py-24 lg:py-32 border-t border-forest/15" data-testid="voices-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="mb-14"
      >
        <span className="text-xs font-bold tracking-[0.3em] uppercase text-terra">Voices</span>
        <h2 className="font-serif font-bold tracking-tighter text-forest text-4xl sm:text-5xl lg:text-6xl mt-4" data-testid="voices-heading">
          Words from the <span className="italic text-terra">classroom.</span>
        </h2>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-8">
        {VOICES.map((v, i) => (
          <motion.blockquote
            key={v.name}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="border border-forest/20 bg-bone p-8 flex flex-col hover:-translate-y-1.5 hover:shadow-xl transition-all duration-300"
            data-testid={`voice-card-${i}`}
          >
            <Quotes size={32} weight="fill" className="text-terra mb-5" />
            <p className="font-serif text-lg leading-relaxed text-forest flex-1">"{v.quote}"</p>
            <footer className="mt-6 pt-5 border-t border-forest/15">
              <p className="font-bold text-sm text-ink">{v.name}</p>
              <p className="text-xs text-moss mt-0.5">{v.role}</p>
            </footer>
          </motion.blockquote>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="mt-16 pt-10 border-t border-forest/15 flex flex-wrap items-center gap-x-10 gap-y-4"
        data-testid="partners-strip"
      >
        <span className="text-[10px] font-bold tracking-[0.3em] uppercase text-moss">In partnership with</span>
        {PARTNERS.map((p) => (
          <span key={p} className="font-serif font-bold text-lg text-forest/50">{p}</span>
        ))}
      </motion.div>
    </div>
  </section>
);
